export default __webpack_public_path__ + "static/media/Picture1.77be32de.png";